import {
  EnumRichiestaDTOStatoOneri,
  RichiestaDTOStatoOneri,
} from '@framework/api-client';
import { t } from '@framework/i18n';
import { Tag, TagProps } from 'antd';
import React from 'react';
import styled, { DefaultTheme, useTheme } from 'styled-components';

const StyledTag = styled(Tag)`
  text-transform: uppercase;
  letter-spacing: 0.03em;
  line-height: 20px;
  padding-inline: 7px;
  &&& {
    font-weight: 600;
  }
`;

function getTagOptions(
  state: RichiestaDTOStatoOneri,
  theme?: DefaultTheme,
): TagProps {
  if (state == null) return { hidden: true };
  const text = state.replace('_', ' ');
  switch (state) {
    case EnumRichiestaDTOStatoOneri.DA_PAGARE:
      return {
        color: '#9E6C00', // theme?.colorWarning,
        children: text,
      };
    case EnumRichiestaDTOStatoOneri.PAGATO:
      return {
        color: theme?.colorSuccess,
        children: text,
      };
    case EnumRichiestaDTOStatoOneri.DA_PAGARE_FACOLTATIVO:
      return {
        color: theme?.colorError ?? '#ff0800',
        children: t(
          'payment.da-pagare-dopo-invio',
          "Da Pagare dopo l'invio",
        ),
      };
    case EnumRichiestaDTOStatoOneri.NESSUNO:
      return { hidden: true };
    default:
      return { children: text };
  }
}

interface Props {
  state: RichiestaDTOStatoOneri;
}

export function PaymentStateTag({ state }: Props) {
  const theme = useTheme();
  return <StyledTag {...getTagOptions(state, theme)} />;
}
